import React from "react";
import {
  FaBell,
  FaCalendarAlt,
  FaEuroSign,
  FaLayerGroup,
  FaUsers,
  FaUserTie,
} from "react-icons/fa";

import AdminStatCard from "./AdminStatCard";
import { formatCurrency, formatCompactNumber } from "../utils/adminDashboardUtils";

function AdminDashboardStatsGrid({ kpis, userStats, eventStats }) {
  return (
    <section className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
      <AdminStatCard
        icon={FaUsers}
        label="Utilisateurs"
        value={formatCompactNumber(kpis.totalUsers)}
        tone="blue"
        description="Total des comptes créés sur la plateforme."
        details={[
          { label: "Expert", value: userStats.judoExpert || 0 },
          { label: "Admin", value: userStats.admin || 0 },
        ]}
      />

      <AdminStatCard
        icon={FaUserTie}
        label="Coachs"
        value={formatCompactNumber(kpis.coachTotal)}
        tone="indigo"
        description="Coachs, Coach Pro et Coach Ultim cumulés."
        details={[
          { label: "Coach", value: userStats.coach || 0 },
          { label: "Pro", value: userStats.coachPro || 0 },
          { label: "Ultim", value: userStats.coachUltim || 0 },
        ]}
      />

      <AdminStatCard
        icon={FaCalendarAlt}
        label="Événements"
        value={formatCompactNumber(kpis.totalEvents)}
        tone="green"
        description="Événements créés dans l’application."
        details={[
          { label: "Partagés", value: eventStats.shared_events_count || 0 },
        ]}
      />

      <AdminStatCard
        icon={FaLayerGroup}
        label="Groupes"
        value={formatCompactNumber(kpis.totalGroups)}
        tone="slate"
        description="Groupes créés par les coachs."
      />

      <AdminStatCard
        icon={FaUsers}
        label="Adhérents"
        value={formatCompactNumber(kpis.totalAdherents)}
        tone="blue"
        description="Profils judokas présents dans la base."
      />

      <AdminStatCard
        icon={FaEuroSign}
        label="Abonnements"
        value={formatCurrency(kpis.subscriptionTotal)}
        tone="amber"
        description="Montant total des achats ou abonnements."
      />

      <AdminStatCard
        icon={FaBell}
        label="Messages non lus"
        value={formatCompactNumber(kpis.unreadMessages)}
        tone={kpis.unreadMessages > 0 ? "red" : "green"}
        description="Messages issus du formulaire de contact."
      />

      <AdminStatCard
        icon={FaCalendarAlt}
        label="Événements partagés"
        value={formatCompactNumber(kpis.sharedEvents)}
        tone="indigo"
        description="Événements visibles ou mutualisés."
      />
    </section>
  );
}

export default AdminDashboardStatsGrid;